import { string } from 'yup';
import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ parent }) => {
  return {
    validation: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => {
        if (parent === 'dailyDocuments') {
          return { driverId: string().required(i18n.t('common.fieldRequiredMessage')) };
        }
        return {};
      },
      default: () => ({}),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
